export enum AppLanguage {
	cs = 'cs',
	sk = 'sk',
}

export function validateLanguageCode(languageCode: string | null): languageCode is AppLanguage {
	if (!languageCode) {
		return false;
	}

	return languageCode === AppLanguage.cs || languageCode === AppLanguage.sk;
}

export function getBcp47LanguageCode(language: AppLanguage): string {
	switch (language) {
		case AppLanguage.cs:
			return 'cs-CZ';
		case AppLanguage.sk:
			return 'sk-SK';
		default:
			throw new Error('Unknown language');
	}
}
